"use strict";
/*
 * Created on 10 19 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var VendorAllowanceBonusConverter_1 = require("./conversions/VendorAllowanceBonusConverter");

var VendorAllowanceBonusConverterImpl_1 = require("./conversions/VendorAllowanceBonusConverterImpl");

var VendorAllowanceConverter_1 = require("./conversions/VendorAllowanceConverter");

var VendorAllowanceConverterImpl_1 = require("./conversions/VendorAllowanceConverterImpl");
/**
 * Configures vendor allowance app module.
 *
 * @author JMe
 */


var VendorAllowanceAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(VendorAllowanceAppModule, _AppModule_1$AppModul);

  function VendorAllowanceAppModule() {
    var _this;

    _classCallCheck(this, VendorAllowanceAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VendorAllowanceAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'vendorAllowanceAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(VendorAllowanceAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(VendorAllowanceConverter_1.VendorAllowanceConverter).to(VendorAllowanceConverterImpl_1.VendorAllowanceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(VendorAllowanceBonusConverter_1.VendorAllowanceBonusConverter).to(VendorAllowanceBonusConverterImpl_1.VendorAllowanceBonusConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return VendorAllowanceAppModule;
}(AppModule_1.AppModule);

exports.VendorAllowanceAppModule = VendorAllowanceAppModule;